var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.renderComponent)?_c('vs-dropdown',{key:'dropdown-key' + _vm.key,ref:"dropdown",staticClass:"ml-1 outlined-none",attrs:{"vs-custom-content":"","vs-trigger-click":""}},[_vm._t("dropdownbtn"),_c('vs-dropdown-menu',{style:(_vm.getStyle)},[_vm._t("dropdownbody")],2)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }